export default function isDisabled({ router }) {
  return router.push({ name: "Error" });
}
